import Box from "@mui/material/Box";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ISaleFunnel } from "src/interface/ISaleFunnel";

export default function SalesFunnelItemList({ rows }: { rows: ISaleFunnel }) {
  const columns: GridColDef[] = [
    {
      field: "rowId",
      headerName: "مرحله",
      minWidth: 100,
      filterable: true,
      align: "left",
      headerAlign: "left",
      flex: 1,
      editable: false,
      sortable: true,
    },
    {
      field: "smsText",
      headerName: "متن پیامک",
      minWidth: 350,
      filterable: true,
      align: "left",
      headerAlign: "left",
      flex: 3,
      editable: true,
      sortable: true,
    },
    {
      field: "daysAfterRegistration",
      headerName: "چند روز پس از ثبت تماس ارسال شود؟",
      minWidth: 300,
      filterable: true,
      align: "left",
      headerAlign: "left",
      flex: 2,
      editable: true,
      sortable: true,
      type: "number",
    },
    {
      field: "timeSendSMS",
      headerName: "ساعت",
      minWidth: 150,
      filterable: true,
      align: "left",
      headerAlign: "left",
      flex: 2,
      editable: true,
      sortable: true,
    },
  ];

  return (
    <Box>
      <DataGrid
        //@ts-ignore
        rows={rows.salesFunnelItem}
        columns={columns}
        editMode="row"
        //rowModesModel={rowModesModel}
        //onRowModesModelChange={handleRowModesModelChange}
        //onRowEditStop={handleRowEditStop}
        //processRowUpdate={processRowUpdate}
        //@ts-ignore

        // slotProps={{
        //   //@ts-ignore
        //   toolbar: {
        //     setRows,
        //     //setRowModesModel,
        //     rows,
        //   },
        // }}
      />
    </Box>
  );
}
